import {
  discordLink,
  whatsappEnglishGroupLink,
  whatsappHebrewGroupLink,
} from "../../constants.ts";

export const Support = () => (
  <>
    Questions? Contact us via WhatsApp (
    <a
      href={whatsappHebrewGroupLink}
      target="_blank"
      rel="noopener noreferrer"
      className="text-success underline mx-1"
    >
      Hebrew
    </a>
    /
    <a
      href={whatsappEnglishGroupLink}
      target="_blank"
      rel="noopener noreferrer"
      className="text-success underline mx-1"
    >
      English
    </a>
    ) or
    <a
      href={discordLink}
      target="_blank"
      rel="noopener noreferrer"
      className="text-indigo-600 dark:text-indigo-400 underline ml-2"
    >
      Discord
    </a>
  </>
);
